export const loginPage = {
	title: {
		sv: "Vi har byggt vår bank för företag som ditt",
	},
	loginInfo: {
		title1: {
			sv: "Gör jobbet tillsammans",
		},
		description1: {
			sv: "Hantera fakturor och betalningar tillsammans",
		},
		title2: {
			sv: "Inga dolda avgifter",
		},
		description2: {
			sv: "Betala bara för det du har behov av",
		},
		title3: {
			sv: "Växla upp när du vill",
		},
		description3: {
			sv: "Lägg till och ta bort tjänster när som helst",
		},
	},
	loginForm: {
		description: {
			sv: "För att du ska kunna fortsätta behöver du först identifiera dig.",
		},
		ssn: {
			sv: "Personnummer",
		},
	},
	loginInProgress: {
		titleOtherDevice: {
			sv: "Identifiera dig med BankID",
		},
		titleSameDevice: {
			sv: "Fortsätt i BankID-appen",
		},
		descriptionInitializing: {
			sv: "", // todo: show some text here?
		},
		descriptionStart: {
			sv: `
Starta BankID-appen på din telefon. &nbsp;
Tryck på QR-symbolen. &nbsp;
Rikta kameran mot QR-koden.`,
		},
		descriptionScanned: {
			sv: "Identifiera dig i BankID-appen",
		},
		descriptionAuthorized: {
			sv: "Nu kan du strax påbörja din ansökan för att bli kund i Svea Bank.",
		},
		descriptionSameDevice: {
			sv: "Följ instruktionerna i appen för att logga in.",
		},
	},
	buttonTextOtherDevice: {
		sv: "BankID på annan enhet",
	},
	buttonTextSameDevice: {
		sv: "BankID på denna enhet",
	},
	rememberMe: {
		sv: "Kom ihåg mig",
	},
	loginHelpLink: {
		sv: "Behöver du hjälp att logga in?",
	},
	otherText: {},
	footerLegalInfo: {
		sv: "© {0} Svea Bank Evenemangsgatan 31a - Box 3028, SE-169 03 Solna - 08 616 99 00",
	},
	footer: {
		visingAddress: {
			sv: "Besöksadress",
		},
		address: {
			sv: "Evenemangsgatan 31 169 81 Solna",
		},
		phone: {
			sv: "08-616 99 00",
		},
		customerService: {
			sv: "Kundtjänst",
		},
		openHours: {
			sv: "Måndag-fredag 08:00-17:00",
		},
		privacy: {
			sv: "Läs mer om hur vi hanterar dina personuppgifter",
		},
		legal: {
			sv: "© {0} Svea Bank — org.nr 556158-7634",
		},
	},
	logoutModal: {
		heading: { sv: "Är du kvar?" },
		body: {
			sv: "Du har varit inaktiv ett tag och vi loggar snart ut dig automatiskt. Vill du fortsätta vara inloggad?",
		},
		stay: { sv: "Stanna kvar" },
		logout: { sv: "Logga ut" },
	},
	consentModal: {
		heading: { sv: "Vi vill ge dig en bättre upplevelse" },
		body: {
			sv: `På Svea använder vi cookies för att webbplatsen ska fungera så bra som
      möjligt.\n\n [Läs mer](https://www.svea.com/sv-se/om-oss/cookies) om hur vi använder
      cookies på Svea.`,
		},
		accept: { sv: "Jag godkänner alla cookies" },
		decline: { sv: "Jag godkänner nödvändiga cookies" },
	},
};
